export default __webpack_public_path__ + "static/NonDig-da2dbbef905e9edd7f36213060ee7599.png";